module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1516-0daad6089795a514a734a479ad313749.png";